import { useMemo } from 'react';
import { useBrandSelectListQuery } from 'api';

export const useBrandMapping = (): Record<string, any> => {
  const { data: brandList = [] } = useBrandSelectListQuery();
  const brandMapping: Record<string, { name: string; id: string }> = useMemo(() => {
    const mapping: Record<string, { name: string; id: string }> = {};
    brandList.forEach((i: { name: string; id: string }) => {
      mapping[i.id] = i;
    });
    return mapping;
  }, [brandList]);

  return {
    brandMapping,
  };
};
